<template>
  <div class="background-03">

    <v-layout row wrap>
      <v-flex xs12 sm2 md2 class="hidden-xs-only ">
        <image-app class="animated fadeInLeft" :imaSize="300" imaSrc="design/banco1-1-3" imaAlt=""></image-app>
      </v-flex>
      <v-flex xs12 sm9 class="animated fadeInUp dura_1">
        <ui-title-one titleAccess="Presupuesto mensual:" titleLevel="h1">
          <template slot="partOne">Presupuesto<br></template>
          <template slot="partThree"> mensual:</template>
        </ui-title-one>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 class="text-xs-center">
        <ui-simple-lsc  :vidTittle="'Presupuesto mensual'" videoEmbed="ADMINISTRACIONDINERO26PresupuestoMensual.mp4"></ui-simple-lsc>
      </v-flex>
      <v-flex xs12 sm5 md5 text-xs-center class="aligner animated fadeIn dura_2">
        <image-app :imaSize="230" imaSrc="contenido/diapositiva_10" imaAlt="Mujer sonriendo recostada en el cuadro de texto"></image-app>
      </v-flex>
      <v-flex xs12 md6 class="animated fadeInUp dura_2 aligner">
        <p class="text-box adorn-bottom">
         Ya ha calculado sus ingresos mensuales. Para continuar con el presupuesto, el siguiente paso es 
         determinar sus gastos. Pero antes de ingresar los datos es importante conocer qué es el gasto y 
         cuántos tipos de gastos existen.  
        </p>
      </v-flex>
    </v-layout>

  </div>
</template>


<script>
export default {
  props: {
    modName: {
      type: String,
      required: false
    }
  },
  data() {
    return {};
  },
  mounted() {
    this.$store.commit("nextShow", true);
  }
};
</script>


// WEBPACK FOOTER //
// davivienda-26.vue?52b8cfac